import { DownloadUrlDto, ModelEventDto } from '@careapp-group/ng-sdk-v2-new';
import { createReducer, on } from '@ngrx/store';
import * as actions from './files.actions';

export interface FilesStateInterface {
  urls: { [id: string]: DownloadUrlDto };
  fileHistory: { [id: string]: ModelEventDto[] };
  loadingIds: { [id: string]: boolean };
  errorIds: { [id: string]: boolean };
}

const initialFilesState: FilesStateInterface = {
  urls: {},
  loadingIds: {},
  errorIds: {},
  fileHistory: {},
};

export const filesReducer = _filesReducerFactory(window);

export function _filesReducerFactory(_window) {
  return createReducer<FilesStateInterface>(
    initialFilesState,
    on(actions.requestFetchDownloadUrl, (state, action) => ({
      ...state,
      loadingIds: { ...state.loadingIds, [action.id]: true },
    })),
    on(actions.responseSuccessDownloadUrl, (state, action) => {
      const { omit, ...errorIds } = state.errorIds;
      return {
        ...state,
        loadingIds: { ...state.loadingIds, [action.id]: false },
        urls: {
          ...state.urls,
          [action.id]: action.url,
        },
        errorIds,
      };
    }),
    on(actions.responseFailDownloadUrl, (state, action) => {
      return {
        ...state,
        loadingIds: { ...state.loadingIds, [action.id]: false },
        errorIds: {
          ...state.errorIds,
          [action.id]: action.error,
        },
      };
    }),
    on(actions.requestLogFileView, (state, action) => ({
      ...state,
      loadingIds: { ...state.loadingIds, [action.fileId]: true },
    })),
    on(actions.successLogFileView, (state, action) => {
      const { omit, ...errorIds } = state.errorIds;
      return {
        ...state,
        loadingIds: { ...state.loadingIds, [action.fileId]: false },
        errorIds,
      };
    }),
    on(actions.failLogFileView, (state, action) => {
      return {
        ...state,
        loadingIds: { ...state.loadingIds, [action.fileId]: false },
        errorIds: {
          ...state.errorIds,
          [action.fileId]: action.error,
        },
      };
    }),
    on(actions.requestFileHistory, (state, action) => ({
      ...state,
      loadingIds: { ...state.loadingIds, [action.fileId]: true },
    })),
    on(actions.successFileHistory, (state, action) => {
      const { omit, ...errorIds } = state.errorIds;
      return {
        ...state,
        fileHistory: { ...state.fileHistory, [action.fileId]: action.history },
        loadingIds: { ...state.loadingIds, [action.fileId]: false },
        errorIds,
      };
    }),
    on(actions.failFileHistory, (state, action) => {
      return {
        ...state,
        loadingIds: { ...state.loadingIds, [action.fileId]: false },
        errorIds: {
          ...state.errorIds,
          [action.fileId]: action.error,
        },
      };
    })
  );
}
